import { MantineThemeOverride } from '@mantine/core'

export const theme: MantineThemeOverride = {
  colors: {
    white: ['#fff'],
    brand: ['#A03033'],
    'samfundet-red': [
      '#ffe7ea',
      '#f2c2c3',
      '#e49c9e',
      '#d77578',
      '#ca4e52',
      '#b13538',
      '#A03033',
      '#641b1e',
      '#3e0f11',
      '#1d0202',
    ],
  },
  primaryColor: 'samfundet-red',
  fontFamily: '"Inter"',
}

// https://www.petarstefanov.com/blog/2020-03-10-react-styled-components-mobile-first-aproach/
